// extracted by mini-css-extract-plugin
module.exports = {"empty-cart-wrapper":"CartEmpty_empty-cart-wrapper__BgXvA"};